import classNames from 'classnames'
import React from 'react'

const GridListThSelectable = ({ selectAllClass, color, onSelect, isSelectedAll, hideSelectAll }) => {

  return (
    <th className='viso-grid-list-th viso-grid-list-th--selectable'>
      <div
        className={classNames('checkbox', selectAllClass, {
          [`checkbox_${color}`]: color,
          'hide' : hideSelectAll
        })}
      >
        <input
          onChange={onSelect}
          type='checkbox'
          className='checkbox__input'
          checked={isSelectedAll}
        />
        <div className='checkbox__check' />
      </div>
    </th>
  )
}

export default GridListThSelectable